import { createSlice } from "@reduxjs/toolkit";
import Swal from 'sweetalert2';
import { createSetupSchedule, updateSetupSchedule, deleteSetupSchedule } from "./Utils/setupScheduleUtils";

const initialState = {
    loading: false,
    error: null,
    currentSetupSchedule: {  // Ini buat menyimpan data form yang lagi aktif
        id: null,
        will_applied_at: "", //2025-03-23
        schedule_date: "", //2025-03-30 00:00:00
        hour_start_at: "", //13:30:00
        hour_end_at: "", //14:30:00
        quota: "", //10
        branch_id: null
    }
};

const setupScheduleSlice = createSlice({
    name: "setupSchedule",
    initialState,
    reducers: {
        setFormData: (state, action) => {
            state.currentSetupSchedule = { ...state.currentSetupSchedule, ...action.payload };
        },
        resetFormData: (state) => {
            state.currentSetupSchedule = initialState.currentSetupSchedule;
        }
    },
    extraReducers: (builder) => {
        builder
            // Handle createSetupSchedule
            .addCase(createSetupSchedule.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(createSetupSchedule.fulfilled, (state) => {
                state.loading = false;
                state.currentSetupSchedule = initialState.currentSetupSchedule;
                Swal.fire({
                    icon: 'success',
                    title: 'Berhasil',
                    text: 'Data berhasil disimpan',
                    toast: true,
                    position: 'center',
                    showConfirmButton: false,
                    timer: 2000,
                    timerProgressBar: true
                });
            })
            .addCase(createSetupSchedule.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            // Handle updateSetupSchedule
            .addCase(updateSetupSchedule.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(updateSetupSchedule.fulfilled, (state) => {
                state.loading = false;
                state.currentSetupSchedule = initialState.currentSetupSchedule;
                Swal.fire({
                    icon: 'success',
                    title: 'Berhasil',
                    text: 'Kuota Jadwal Cabang berhasil diubah',
                    toast: true,
                    position: 'center',
                    showConfirmButton: false,
                    timer: 2000,
                    timerProgressBar: true
                });
            })
            .addCase(updateSetupSchedule.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            // Handle deleteSetupSchedule
            .addCase(deleteSetupSchedule.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(deleteSetupSchedule.fulfilled, (state) => {
                state.loading = false;
                Swal.fire({
                    icon: 'success',
                    title: 'Success',
                    text: 'Data Berhasil Dihapus',
                    toast: true,
                    position: 'center',
                    showConfirmButton: false,
                    timer: 2000,
                    timerProgressBar: true,
                });
            })
            .addCase(deleteSetupSchedule.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
    }
});

export const { setFormData, resetFormData } = setupScheduleSlice.actions;
export default setupScheduleSlice.reducer;
